import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {ApiProvider} from "../api/api";
import * as io from "socket.io-client";
import {Events} from "ionic-angular";
import {LocalStorageWrapper} from "../local-storage-wrapper/local-storage-wrapper";


/*
  Generated class for the ChatClientProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ChatClientProvider {
  private socket: any;
  public connected: boolean = false;
  private connectionPromise: Promise<any>;
  public supportAvailable: boolean;


  constructor(private api: ApiProvider, public events: Events, public localStorage: LocalStorageWrapper) {
    if(this.localStorage.getItem('api_token')) {
      this.connect();
    }
  }

  loadMessageHistory(channel: string, lastId: number) {
    var me = this;
    return new Promise( (resolve, reject) => {
      me.socket.emit('loadConversationHistory', {conversation_id: channel, start_id: lastId?lastId:null}, (data: any) => {
        resolve(data);
      })
    });
  }

  checkConnection() {
    return this.connectionPromise;
  }

  connect() {
    var me = this;
    this.connectionPromise = new Promise<any>(resolve => {
      me.socket = io(me.api.chatHost, {
        transportOptions: {
          polling: {
            extraHeaders: {
              'Content-Type': 'application/json'
            }
          }
        }
      });
      console.log('connecting to ', me.api.chatHost);

      me.socket.on('connect', () => {
        console.log('connect listener');
        me.socket.emit('authorize', {token: this.localStorage.getItem('api_token')}, (e) => {
          console.log(e);
          if(!e.status) {
            me.socket.close();
            me.connected = true;
            me.reconnect(30);
          } else {
            me.supportAvailable = e.supportAvailable;
            resolve();
            console.log('authorized');
          }
        });
      });

      me.socket.on('messageReceived', function(msg) {
        console.log('socket messageReceived', msg);
        me.events.publish('message:received', msg);
      });

      me.socket.on('supportAvailable', function(msg) {
        console.log('socket supportAvailable', msg);
        me.supportAvailable = msg.status
        me.events.publish('chat:supportAvailable', {status: me.supportAvailable});
      });

      me.socket.on('disconnect', (e: any) => {
        console.log('disconnected');
        // me.reconnect(3);
      })
    })


  }

  sendMessage(channel, message) {
    this.socket.emit('sendMessage', {conversation_id: channel, message: message, type: 'text'});
  }

  reconnect(timeout: number) {
    var me = this;
    setTimeout(() => {
      me.connect();
    }, timeout*1000);
  }

  loadConversations() {
    var me = this;
    return new Promise( (resolve, reject) => {
      me.socket.emit('loadConversations', {}, (data: any) => {
        console.log('conversation response', data);
        resolve(data);
      })
    });
  }

  close() {
    this.connectionPromise = null;
    this.socket.close();
  }

  markRead(channel: string) {
    var me = this;
    return new Promise( (resolve, reject) => {
      me.socket.emit('markRead', {conversation_id: channel}, (data: any) => {
        resolve(data);
      })
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/chat-client/chat-client.ts